import type { oz } from '@weft/utils';
import { withNullAsOptional } from '../../utils/literal-transforms';
import { BankDetailsSchema } from '../bank-details';
import { BillingSettingsSchema } from '../billing-settings/billing-settings-schema';
import { NewAccountSettingsSchema } from './new-account-settings-schema';

export const AccountSettingsSchema = NewAccountSettingsSchema.extend({
  billingSettings: BillingSettingsSchema.optional(),
  bankDetails: withNullAsOptional(BankDetailsSchema),
}).openapi('AccountSettings');

export type AccountSettings = oz.infer<typeof AccountSettingsSchema>;